module.exports = __webpack_public_path__ + "static/img/4.20f74b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4.jpg
// module id = 3lFO
// module chunks = 0